<script setup lang="ts">
defineOptions({
	name: 'IconBarCode',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		:class="props.class"
		viewBox="0 0 163 23"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M77.1262 0.0500297C77.2676 0.0397065 77.3886 0.0162405 77.5195 0.0627386C77.6084 0.193948 77.5698 2.3785 77.5694 2.67128L77.5698 22.9539C77.4289 22.9447 77.2672 22.9453 77.1245 22.9423L77.1262 0.0500297Z"
			fill="currentColor"
		/>
		<path
			d="M10.7357 0.0423504C10.8749 0.0385334 11.0295 0.0133755 11.1377 0.0839902C11.2511 0.345369 11.169 20.653 11.1828 22.9554C11.0275 22.9492 10.919 22.9918 10.7775 22.9255C10.6984 22.7769 10.7343 20.7194 10.7343 20.385L10.7357 0.0423504Z"
			fill="currentColor"
		/>
		<path
			d="M1.36509 0.0465561C1.50853 0.0397896 1.63719 0.0173215 1.76324 0.0757478C1.84203 0.215069 1.80634 2.29001 1.8063 2.60834L1.80639 22.9615C1.67387 22.9628 1.5061 22.9845 1.40394 22.9141C1.32112 22.7189 1.366 17.4284 1.36596 16.7081L1.36509 0.0465561Z"
			fill="currentColor"
		/>
		<path
			d="M78.4551 0C78.5214 0.0189549 78.5869 0.0415098 78.6528 0.0629805C78.7131 0.186036 78.6827 3.53694 78.6827 4.03319L78.6814 19.0157C78.6793 20.1656 78.7135 21.735 78.6602 22.9013C78.6589 22.934 78.5696 22.9696 78.5262 22.9933C78.423 22.9725 78.3462 22.966 78.2574 22.9102C78.2205 22.623 78.2422 21.63 78.2422 21.2747L78.2413 6.457C78.2409 4.73956 78.2227 1.91319 78.2617 0.0921722C78.2626 0.0501851 78.3939 0.0212972 78.4551 0Z"
			fill="currentColor"
		/>
		<path
			d="M76.0377 0.0521203C76.1808 0.0418404 76.2849 0.0221917 76.4215 0.0637451C76.5065 0.202936 76.4753 0.589148 76.4753 0.771367C76.4757 2.12194 76.4753 3.47256 76.4753 4.82313L76.4766 22.9566C76.3205 22.9465 76.2186 22.985 76.0794 22.9276C75.9983 22.781 76.0325 20.6337 76.0325 20.2457L76.0377 0.0521203Z"
			fill="currentColor"
		/>
		<path
			d="M28.1612 0.0510838C28.362 0.0506934 28.4444 0.00870716 28.5802 0.107299C28.6187 0.314892 28.6008 1.66555 28.6005 1.98093L28.5991 22.9638C28.4042 22.9497 28.2996 22.9923 28.1786 22.8882C28.1323 22.6815 28.1521 21.406 28.1521 21.0759L28.154 16.6345C28.1568 11.1358 28.096 5.54047 28.1612 0.0510838Z"
			fill="currentColor"
		/>
		<path
			d="M67.0602 0.0406082L67.0849 0.0611257C67.1313 0.327015 67.1092 2.21223 67.1092 2.58066L67.1113 21.189C67.1118 21.6934 67.1343 22.4293 67.0936 22.9067C66.9739 22.9771 66.8833 22.9495 66.725 22.9491L66.6925 22.9244C66.6435 22.7285 66.663 20.8738 66.663 20.5722L66.6621 1.81643C66.6621 1.31671 66.6404 0.572561 66.6825 0.0891882C66.7736 0.027075 66.9414 0.0423433 67.0602 0.0406082Z"
			fill="currentColor"
		/>
		<path
			d="M27.0649 0.0495575C27.2138 0.0414464 27.3289 0.0183264 27.4614 0.0785745C27.5337 0.191176 27.5026 2.26464 27.5026 2.6057L27.5081 22.9539C27.3617 22.9486 27.2077 22.9933 27.098 22.9218C27.0039 22.728 27.0453 2.16293 27.0649 0.0495575Z"
			fill="currentColor"
		/>
		<path
			d="M11.8274 0.0499895C11.9718 0.0424422 12.1103 0.0158098 12.23 0.0826943C12.3288 0.270205 12.2675 20.7497 12.2748 22.934C12.1723 22.9603 11.9296 22.9662 11.8423 22.9027C11.7845 22.4643 11.8254 21.222 11.8254 20.6939L11.8274 0.0499895Z"
			fill="currentColor"
		/>
		<path
			d="M4.874 0.050827C5.01917 0.0398531 5.14887 0.0122666 5.27536 0.0723412C5.3763 0.241071 5.31508 20.7705 5.31508 22.9635C5.16261 22.9504 5.05885 22.9818 4.92113 22.9251C4.83172 22.7726 4.86784 20.5685 4.86784 20.1941L4.874 0.050827Z"
			fill="currentColor"
		/>
		<path
			d="M17.689 0.0418663C17.8374 0.0345358 17.9653 0.0111133 18.0951 0.0730964C18.165 0.206518 18.134 6.70841 18.1339 7.45698L18.1396 22.9601C17.9913 22.9528 17.8437 22.9934 17.7284 22.9228C17.6267 22.7188 17.6885 2.29902 17.689 0.0418663Z"
			fill="currentColor"
		/>
		<path
			d="M37.5237 0.0489678C37.6693 0.0385578 37.7783 0.0167831 37.9144 0.0646259C38.0004 0.188679 37.9636 2.3256 37.9636 2.6281L37.9628 22.9628C37.7646 22.9566 37.6597 22.9927 37.5385 22.8875C37.495 22.6784 37.5138 21.3294 37.5138 20.9888L37.5154 5.8995C37.5149 3.96622 37.4915 1.9789 37.5237 0.0489678Z"
			fill="currentColor"
		/>
		<path
			d="M44.4763 0.0513211C44.622 0.0408243 44.7382 0.0173148 44.8722 0.0679336C44.9585 0.191162 44.9208 2.27261 44.9208 2.64195L44.9204 22.964C44.7725 22.9652 44.6558 22.9804 44.5206 22.9244C44.4369 22.7797 44.4716 20.5757 44.4716 20.1946L44.4763 0.0513211Z"
			fill="currentColor"
		/>
		<path
			d="M50.3389 0.0479253C50.4837 0.0402479 50.616 0.0173021 50.7452 0.0725621C50.8206 0.209497 50.7872 2.28426 50.7872 2.58854L50.789 22.9562C50.6385 22.9508 50.501 22.9945 50.3779 22.9227C50.3024 22.7767 50.3354 20.6977 50.3354 20.3105L50.3389 0.0479253Z"
			fill="currentColor"
		/>
		<path
			d="M59.7087 0.0542264C59.8857 0.0463755 59.9941 0.00920255 60.1246 0.0863236C60.2117 0.350955 60.1562 4.74751 60.1562 5.31563L60.1597 22.9535C60.0053 22.9471 59.8666 22.9918 59.7443 22.9228C59.6701 22.7806 59.7022 20.4643 59.7022 20.0818L59.7087 0.0542264Z"
			fill="currentColor"
		/>
		<path
			d="M21.1924 0.0507853C21.3372 0.0396378 21.454 0.0168222 21.5902 0.0610215C21.6871 0.19748 21.6461 2.29879 21.6461 2.66318L21.6494 22.9478C21.4802 22.9395 21.3947 22.9825 21.2363 22.9212C21.1522 22.7764 21.1876 20.633 21.1876 20.2505L21.1924 0.0507853Z"
			fill="currentColor"
		/>
		<path
			d="M13.2875 0.0279146L13.3539 0.0644793C13.4107 0.271335 13.3751 1.77741 13.375 2.07856L13.3731 17.9216L13.3764 21.0865C13.3776 21.6138 13.4015 22.3829 13.3614 22.8961C13.2603 22.9752 13.1356 22.9519 12.9975 22.9503L12.9504 22.9231C12.8826 22.7676 12.9167 20.0623 12.9166 19.6798L12.9121 2.38726C12.9111 1.71247 12.8791 0.73532 12.9332 0.0987897C13.0592 0.0152058 13.1181 0.0392355 13.2875 0.0279146Z"
			fill="currentColor"
		/>
		<path
			d="M62.017 0.0139573C62.2031 0.0223721 62.1944 -0.00781704 62.3279 0.0928567C62.3882 0.217213 62.3596 3.00346 62.3596 3.40412L62.36 20.8626C62.3605 21.4821 62.3913 22.2897 62.3657 22.8894L62.285 22.9499C62.1506 22.9494 62.0257 22.9684 61.9212 22.8968C61.8748 22.6125 61.9008 20.5378 61.9013 20.1604L61.9021 1.56462C61.9017 1.11881 61.893 0.643764 61.9134 0.197868C61.9195 0.0619298 61.9268 0.0858299 62.017 0.0139573Z"
			fill="currentColor"
		/>
		<path
			d="M54.1323 0.0122126C54.2563 0.0324688 54.2051 0.00657383 54.2953 0.0845624L54.2944 17.879C54.2953 19.3359 54.3122 21.3896 54.2823 22.9032C54.2814 22.9452 54.1609 22.975 54.1019 22.9981C54.0278 22.9769 53.9536 22.9549 53.8799 22.9323C53.8023 22.8023 53.8348 21.4745 53.8348 21.2137V3.91906C53.8348 3.45355 53.8066 0.175866 53.8799 0.056975L54.1323 0.0122126Z"
			fill="currentColor"
		/>
		<path
			d="M60.8038 0.051354C60.9517 0.0405535 61.0644 0.0175215 61.2015 0.0680101C61.2873 0.189764 61.2513 2.29884 61.2513 2.66354L61.2496 22.9515C61.0475 22.9511 60.9469 22.9902 60.816 22.888C60.7704 22.6825 60.7891 21.3058 60.7891 21.035V5.69433C60.7887 3.90129 60.7379 1.82709 60.8038 0.051354Z"
			fill="currentColor"
		/>
		<path
			d="M70.392 0.00348932C70.5173 0.0268685 70.5251 0.00691584 70.6027 0.0790054C70.6626 0.676325 70.6192 2.039 70.6192 2.71235L70.6209 17.621C70.6214 19.347 70.6474 21.1362 70.617 22.858C70.5481 22.9788 70.5164 22.9528 70.346 23C70.2129 22.9443 70.2463 22.9784 70.1661 22.8732C70.101 18.4852 70.1596 13.9475 70.1596 9.54941V3.37834C70.1596 2.92702 70.108 0.317743 70.2155 0.0597905L70.392 0.00348932Z"
			fill="currentColor"
		/>
		<path
			d="M34.0228 0.0438646C34.1659 0.0369679 34.2689 0.0198357 34.4042 0.0651193C34.4975 0.193293 34.4576 2.31143 34.4576 2.66628L34.4559 22.9678C34.2775 22.9419 34.2129 22.9943 34.0606 22.9223C33.9376 22.6376 34.0193 2.3555 34.0228 0.0438646Z"
			fill="currentColor"
		/>
		<path
			d="M72.7899 0.0344206L73.6476 0.0279146C73.681 2.29002 73.6515 4.62746 73.6515 6.89438L73.6575 22.9386L72.7222 22.9445L71.8355 22.9463C71.7882 20.3307 71.8329 17.5685 71.8324 14.943L71.835 0.047606C72.1446 0.0368923 72.4781 0.0383243 72.7899 0.0344206Z"
			fill="currentColor"
		/>
		<path
			d="M41.5421 0.0348932L42.4787 0.0414429L42.4783 22.9546L41.5204 22.9476V2.44573C41.52 1.82828 41.484 0.610308 41.5421 0.0348932Z"
			fill="currentColor"
		/>
		<path
			d="M16.3354 0.0314039C16.6508 0.0319678 16.9662 0.0350477 17.2815 0.0405997C17.3148 2.62394 17.2847 5.27767 17.2848 7.86578L17.2847 22.9537L16.3329 22.9537C16.2786 19.8475 16.3278 16.5907 16.3277 13.4745L16.3354 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M51.3427 0.0364022L53.1379 0.0331486L53.1448 22.8364L53.1335 22.8871C52.9644 22.9893 51.6085 22.9456 51.3188 22.9437C51.2828 21.1322 51.3149 19.2004 51.3149 17.377L51.3119 2.10566C51.3115 1.75553 51.2872 0.323806 51.3427 0.0364022Z"
			fill="currentColor"
		/>
		<path
			d="M32.6655 0.0245908C32.9766 0.0226823 33.2965 0.0376904 33.6081 0.0481872C33.6715 2.77549 33.6155 5.73077 33.6157 8.47281L33.6124 22.9567C33.308 22.9458 32.9614 22.9547 32.6534 22.956L32.6531 7.84023C32.6531 5.28643 32.6065 2.56759 32.6655 0.0245908Z"
			fill="currentColor"
		/>
		<path
			d="M57.858 0.0261699L58.8029 0.0420451C58.8727 2.53863 58.8107 5.3529 58.8107 7.87039L58.8094 22.9547L57.8489 22.9483L57.845 10.0696C57.845 6.75743 57.8004 3.33066 57.858 0.0261699Z"
			fill="currentColor"
		/>
		<path
			d="M25.1898 0.0279146L26.1617 0.0430525C26.2083 3.29029 26.1657 6.65612 26.166 9.91225L26.1599 22.9418C25.8437 22.9508 25.504 22.9453 25.1859 22.9453L25.1898 0.0279146Z"
			fill="currentColor"
		/>
		<path
			d="M30.5368 0.0366379C30.9951 0.0644847 31.8149 0.0420605 32.297 0.0425376L32.2986 22.957C31.7073 22.948 31.0994 22.9531 30.5068 22.9517L30.5085 6.08782L30.5047 1.9294C30.5044 1.60639 30.4828 0.291077 30.5368 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M63.1699 0.0366379C63.7631 0.0409754 64.3558 0.042016 64.949 0.0397605L64.9469 22.9539C64.3567 22.9418 63.7492 22.9507 63.1577 22.9525L63.156 2.82562C63.1556 1.95582 63.127 0.895466 63.1699 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M46.8332 0.0331486C47.4173 0.0521903 48.0417 0.0418679 48.6289 0.0422583L48.6306 20.3236C48.6315 21.0624 48.6674 22.242 48.6176 22.9565C48.0218 22.9512 47.426 22.9502 46.8302 22.9533L46.8332 0.0331486Z"
			fill="currentColor"
		/>
		<path
			d="M67.6536 0.0287531C68.2611 0.0260638 68.869 0.0298375 69.477 0.0401607L69.4774 22.9387C68.8755 22.9539 68.2542 22.9445 67.651 22.9427L67.6536 0.0287531Z"
			fill="currentColor"
		/>
		<path
			d="M79.4928 0.0462098C80.0886 0.0371878 80.6844 0.0359736 81.2802 0.0425233L81.282 20.27C81.282 20.6213 81.3149 22.8395 81.2299 22.9543C80.6489 22.945 80.0678 22.9467 79.4868 22.9594L79.4928 0.0462098Z"
			fill="currentColor"
		/>
		<path
			d="M23.9252 0.0360554L24.6575 0.0331486L24.6545 22.9531L23.6858 22.9498L22.8689 22.954C22.8328 20.0478 22.8643 17.0745 22.8642 14.1639L22.8669 0.0504984C23.2128 0.0391774 23.5776 0.0403929 23.9252 0.0360554Z"
			fill="currentColor"
		/>
		<path
			d="M45.6885 0.0281541C45.8195 0.0214743 45.8733 0.00729015 45.9908 0.0555667C46.0658 0.185779 46.035 3.50242 46.035 3.92728L46.0337 21.3816C46.0337 21.6862 46.0602 22.6859 46.0172 22.9143L45.9448 22.9621C45.8052 22.9614 45.7176 22.9748 45.5949 22.9098C45.5303 22.744 45.571 19.2625 45.571 18.835L45.5689 2.42702C45.5684 1.7331 45.5402 0.757637 45.578 0.0845413L45.6885 0.0281541Z"
			fill="currentColor"
		/>
		<path
			d="M7.46859 0.0347449L8.3383 0.0314039L8.33735 15.0671C8.33726 17.6173 8.40166 20.4345 8.32378 22.9564C8.04713 22.9474 7.75161 22.95 7.47319 22.9473L6.53773 22.9572L6.53505 0.0503157C6.83928 0.0392984 7.16258 0.0393427 7.46859 0.0347449Z"
			fill="currentColor"
		/>
		<path
			d="M48.9853 0.0265057C49.2979 0.0238165 49.6188 0.0378697 49.9319 0.0475857C49.9661 2.61271 49.9349 5.25746 49.9349 7.82822L49.9353 22.9578L48.9831 22.957L48.9853 0.0265057Z"
			fill="currentColor"
		/>
		<path
			d="M2.3458 0.0358053C2.94428 0.0440899 3.5429 0.0438285 4.14138 0.0348932L4.13934 22.9457L2.34307 22.9511C2.31115 21.6972 2.33873 20.3214 2.33869 19.0601L2.33626 4.15189C2.33583 2.80874 2.31124 1.37046 2.3458 0.0358053Z"
			fill="currentColor"
		/>
		<path
			d="M39.8345 0.0354042L40.9879 0.0331486L40.9844 22.9466L40.579 22.9505L39.1848 22.9492C39.1445 20.3501 39.1811 17.6476 39.181 15.0415L39.1824 0.0496313L39.8345 0.0354042Z"
			fill="currentColor"
		/>
		<path
			d="M65.3157 0.0261699C65.6266 0.0300303 65.9371 0.0371007 66.2475 0.0473373C66.2879 2.65826 66.2558 5.35121 66.2558 7.96725L66.2567 22.9555L65.3062 22.9567C65.3617 20.8159 65.3079 18.4186 65.3079 16.261L65.3157 0.0261699Z"
			fill="currentColor"
		/>
		<path
			d="M18.6875 0.0380955C19.2794 0.0305483 19.8713 0.0293764 20.4632 0.0346248C20.5211 2.53143 20.4714 5.23657 20.4714 7.74738L20.4755 22.9483L18.6689 22.9505C18.605 17.8219 18.6669 12.552 18.6663 7.41205L18.6642 2.49066C18.6639 1.94426 18.6278 0.525632 18.6875 0.0380955Z"
			fill="currentColor"
		/>
		<path
			d="M0.0175964 0.0366379L0.95629 0.0372891C1.02172 2.49584 0.962188 5.2466 0.962144 7.72454L0.963228 22.9512L0.0115039 22.9538L0.00849467 8.33621C0.00831255 5.58311 -0.0155843 2.78632 0.0175964 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M43.3868 0.0502178C43.5294 0.0412825 43.6344 0.0219799 43.7688 0.0671334C43.8599 0.195394 43.8213 2.33175 43.8213 2.66439L43.8243 22.9588C43.6691 22.9514 43.5693 22.9929 43.4284 22.9255C43.3508 22.7771 43.385 20.639 43.385 20.3509L43.3868 0.0502178Z"
			fill="currentColor"
		/>
		<path
			d="M56.1408 0.0351142L57.3107 0.0279146C57.3571 1.89882 57.3177 3.96235 57.3177 5.84743L57.3168 17.1655C57.3164 19.0111 57.2682 21.1114 57.335 22.9414L56.688 22.9469L55.5082 22.9467C55.4401 20.4437 55.5038 17.6243 55.5038 15.1004L55.5047 0.0485617L56.1408 0.0351142Z"
			fill="currentColor"
		/>
		<path
			d="M74.1777 0.0314039L75.1274 0.0396016L75.1282 22.9531L74.1725 22.9468L74.1777 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M8.87142 0.0314039L9.83085 0.0320115L9.82669 22.94C9.52181 22.9518 9.17062 22.9461 8.86179 22.9475L8.86002 8.02779C8.8598 5.4147 8.81271 2.62658 8.87142 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M14.1897 0.0348932C14.7066 0.0610918 15.4472 0.0399686 15.9811 0.0413132L15.983 20.4874C15.9834 21.0794 16.0203 22.4182 15.9674 22.9525C15.3804 22.9442 14.771 22.9522 14.1822 22.9529L14.1769 3.11401C14.1765 2.11508 14.1554 1.02866 14.1897 0.0348932Z"
			fill="currentColor"
		/>
		<path
			d="M29.5547 0.00872331C29.6604 0.0450717 29.6175 0.0150558 29.6879 0.10198C29.72 0.803876 29.6928 1.62484 29.692 2.33823L29.6934 19.5277C29.6939 19.8587 29.7277 22.8084 29.6551 22.937L29.3962 22.9939L29.304 22.9419C29.2197 22.8061 29.2446 22.7275 29.2446 22.5463C29.2416 17.7533 29.2429 12.9569 29.243 8.16425L29.2418 2.87734C29.2415 2.10921 29.2039 0.859961 29.2556 0.120718C29.3449 0.00985109 29.3813 0.037134 29.5547 0.00872331Z"
			fill="currentColor"
		/>
		<path
			d="M34.9991 0.036687C35.5912 0.0237179 36.2087 0.032653 36.8028 0.0327398C36.8295 1.96805 36.8052 3.96288 36.8052 5.90192L36.8051 17.2779C36.8052 19.1465 36.7816 21.0774 36.8171 22.9419C36.2178 22.9559 35.5908 22.947 34.9893 22.9473C34.9505 21.4017 34.9851 19.707 34.985 18.1521L34.9836 3.03799C34.9833 2.22271 34.9405 0.819088 34.9991 0.036687Z"
			fill="currentColor"
		/>
		<path
			d="M158.415 0.0500297C158.557 0.0397065 158.678 0.0162405 158.809 0.0627386C158.897 0.193948 158.859 2.3785 158.858 2.67128L158.859 22.9539C158.718 22.9447 158.556 22.9453 158.414 22.9423L158.415 0.0500297Z"
			fill="currentColor"
		/>
		<path
			d="M92.0248 0.0423504C92.164 0.0385334 92.3185 0.0133755 92.4268 0.0839902C92.5401 0.345369 92.4581 20.653 92.4719 22.9554C92.3165 22.9492 92.208 22.9918 92.0666 22.9255C91.9875 22.7769 92.0234 20.7194 92.0234 20.385L92.0248 0.0423504Z"
			fill="currentColor"
		/>
		<path
			d="M82.6542 0.0465561C82.7976 0.0397896 82.9263 0.0173215 83.0523 0.0757478C83.1311 0.215069 83.0954 2.29001 83.0954 2.60834L83.0954 22.9615C82.9629 22.9628 82.7952 22.9845 82.693 22.9141C82.6102 22.7189 82.6551 17.4284 82.655 16.7081L82.6542 0.0465561Z"
			fill="currentColor"
		/>
		<path
			d="M159.744 0C159.81 0.0189549 159.876 0.0415098 159.942 0.0629805C160.002 0.186036 159.972 3.53694 159.972 4.03319L159.97 19.0157C159.968 20.1656 160.003 21.735 159.949 22.9013C159.948 22.934 159.859 22.9696 159.815 22.9933C159.712 22.9725 159.635 22.966 159.546 22.9102C159.51 22.623 159.531 21.63 159.531 21.2747L159.53 6.457C159.53 4.73956 159.512 1.91319 159.551 0.0921722C159.552 0.0501851 159.683 0.0212972 159.744 0Z"
			fill="currentColor"
		/>
		<path
			d="M157.327 0.0521203C157.47 0.0418404 157.574 0.0221917 157.711 0.0637451C157.796 0.202936 157.764 0.589148 157.764 0.771367C157.765 2.12194 157.764 3.47256 157.764 4.82313L157.766 22.9566C157.61 22.9465 157.508 22.985 157.368 22.9276C157.287 22.781 157.322 20.6337 157.322 20.2457L157.327 0.0521203Z"
			fill="currentColor"
		/>
		<path
			d="M109.45 0.0510838C109.651 0.0506934 109.733 0.00870716 109.869 0.107299C109.908 0.314892 109.89 1.66555 109.89 1.98093L109.888 22.9638C109.693 22.9497 109.589 22.9923 109.468 22.8882C109.421 22.6815 109.441 21.406 109.441 21.0759L109.443 16.6345C109.446 11.1358 109.385 5.54047 109.45 0.0510838Z"
			fill="currentColor"
		/>
		<path
			d="M148.349 0.0406082L148.374 0.0611257C148.42 0.327015 148.398 2.21223 148.398 2.58066L148.4 21.189C148.401 21.6934 148.423 22.4293 148.383 22.9067C148.263 22.9771 148.172 22.9495 148.014 22.9491L147.982 22.9244C147.933 22.7285 147.952 20.8738 147.952 20.5722L147.951 1.81643C147.951 1.31671 147.929 0.572561 147.972 0.0891882C148.063 0.027075 148.23 0.0423433 148.349 0.0406082Z"
			fill="currentColor"
		/>
		<path
			d="M108.354 0.0495575C108.503 0.0414464 108.618 0.0183264 108.75 0.0785745C108.823 0.191176 108.792 2.26464 108.792 2.6057L108.797 22.9539C108.651 22.9486 108.497 22.9933 108.387 22.9218C108.293 22.728 108.334 2.16293 108.354 0.0495575Z"
			fill="currentColor"
		/>
		<path
			d="M93.1165 0.0499895C93.2608 0.0424422 93.3994 0.0158098 93.5191 0.0826943C93.6179 0.270205 93.5565 20.7497 93.5639 22.934C93.4613 22.9603 93.2187 22.9662 93.1314 22.9027C93.0736 22.4643 93.1145 21.222 93.1144 20.6939L93.1165 0.0499895Z"
			fill="currentColor"
		/>
		<path
			d="M86.1631 0.050827C86.3082 0.0398531 86.4379 0.0122666 86.5644 0.0723412C86.6654 0.241071 86.6041 20.7705 86.6041 22.9635C86.4517 22.9504 86.3479 22.9818 86.2102 22.9251C86.1208 22.7726 86.1569 20.5685 86.1569 20.1941L86.1631 0.050827Z"
			fill="currentColor"
		/>
		<path
			d="M98.978 0.0418663C99.1264 0.0345358 99.2543 0.0111133 99.3842 0.0730964C99.4541 0.206518 99.423 6.70841 99.423 7.45698L99.4287 22.9601C99.2804 22.9528 99.1328 22.9934 99.0175 22.9228C98.9158 22.7188 98.9775 2.29902 98.978 0.0418663Z"
			fill="currentColor"
		/>
		<path
			d="M118.813 0.0489678C118.958 0.0385578 119.067 0.0167831 119.203 0.0646259C119.289 0.188679 119.253 2.3256 119.253 2.6281L119.252 22.9628C119.054 22.9566 118.949 22.9927 118.828 22.8875C118.784 22.6784 118.803 21.3294 118.803 20.9888L118.804 5.8995C118.804 3.96622 118.781 1.9789 118.813 0.0489678Z"
			fill="currentColor"
		/>
		<path
			d="M125.765 0.0513211C125.911 0.0408243 126.027 0.0173148 126.161 0.0679336C126.248 0.191162 126.21 2.27261 126.21 2.64195L126.209 22.964C126.062 22.9652 125.945 22.9804 125.81 22.9244C125.726 22.7797 125.761 20.5757 125.761 20.1946L125.765 0.0513211Z"
			fill="currentColor"
		/>
		<path
			d="M131.628 0.0479253C131.773 0.0402479 131.905 0.0173021 132.034 0.0725621C132.11 0.209497 132.076 2.28426 132.076 2.58854L132.078 22.9562C131.928 22.9508 131.79 22.9945 131.667 22.9227C131.592 22.7767 131.624 20.6977 131.624 20.3105L131.628 0.0479253Z"
			fill="currentColor"
		/>
		<path
			d="M140.998 0.0542264C141.175 0.0463755 141.283 0.00920255 141.414 0.0863236C141.501 0.350955 141.445 4.74751 141.445 5.31563L141.449 22.9535C141.294 22.9471 141.156 22.9918 141.033 22.9228C140.959 22.7806 140.991 20.4643 140.991 20.0818L140.998 0.0542264Z"
			fill="currentColor"
		/>
		<path
			d="M102.481 0.0507853C102.626 0.0396378 102.743 0.0168222 102.879 0.0610215C102.976 0.19748 102.935 2.29879 102.935 2.66318L102.938 22.9478C102.769 22.9395 102.684 22.9825 102.525 22.9212C102.441 22.7764 102.477 20.633 102.477 20.2505L102.481 0.0507853Z"
			fill="currentColor"
		/>
		<path
			d="M94.5766 0.0279146L94.643 0.0644793C94.6998 0.271335 94.6641 1.77741 94.6641 2.07856L94.6621 17.9216L94.6655 21.0865C94.6666 21.6138 94.6906 22.3829 94.6505 22.8961C94.5493 22.9752 94.4247 22.9519 94.2865 22.9503L94.2395 22.9231C94.1716 22.7676 94.2058 20.0623 94.2057 19.6798L94.2012 2.38726C94.2001 1.71247 94.1681 0.73532 94.2222 0.0987897C94.3483 0.0152058 94.4071 0.0392355 94.5766 0.0279146Z"
			fill="currentColor"
		/>
		<path
			d="M143.306 0.0139573C143.492 0.0223721 143.483 -0.00781704 143.617 0.0928567C143.677 0.217213 143.649 3.00346 143.649 3.40412L143.649 20.8626C143.65 21.4821 143.68 22.2897 143.655 22.8894L143.574 22.9499C143.44 22.9494 143.315 22.9684 143.21 22.8968C143.164 22.6125 143.19 20.5378 143.19 20.1604L143.191 1.56462C143.191 1.11881 143.182 0.643764 143.202 0.197868C143.209 0.0619298 143.216 0.0858299 143.306 0.0139573Z"
			fill="currentColor"
		/>
		<path
			d="M135.421 0.0122126C135.545 0.0324688 135.494 0.00657383 135.584 0.0845624L135.583 17.879C135.584 19.3359 135.601 21.3896 135.571 22.9032C135.57 22.9452 135.45 22.975 135.391 22.9981C135.317 22.9769 135.243 22.9549 135.169 22.9323C135.091 22.8023 135.124 21.4745 135.124 21.2137V3.91906C135.124 3.45355 135.096 0.175866 135.169 0.056975L135.421 0.0122126Z"
			fill="currentColor"
		/>
		<path
			d="M142.093 0.051354C142.241 0.0405535 142.353 0.0175215 142.491 0.0680101C142.576 0.189764 142.54 2.29884 142.54 2.66354L142.539 22.9515C142.337 22.9511 142.236 22.9902 142.105 22.888C142.06 22.6825 142.078 21.3058 142.078 21.035V5.69433C142.078 3.90129 142.027 1.82709 142.093 0.051354Z"
			fill="currentColor"
		/>
		<path
			d="M151.681 0.00348932C151.806 0.0268685 151.814 0.00691584 151.892 0.0790054C151.952 0.676325 151.908 2.039 151.908 2.71235L151.91 17.621C151.91 19.347 151.936 21.1362 151.906 22.858C151.837 22.9788 151.806 22.9528 151.635 23C151.502 22.9443 151.535 22.9784 151.455 22.8732C151.39 18.4852 151.449 13.9475 151.449 9.54941V3.37834C151.449 2.92702 151.397 0.317743 151.505 0.0597905L151.681 0.00348932Z"
			fill="currentColor"
		/>
		<path
			d="M115.312 0.0438646C115.455 0.0369679 115.558 0.0198357 115.693 0.0651193C115.787 0.193293 115.747 2.31143 115.747 2.66628L115.745 22.9678C115.567 22.9419 115.502 22.9943 115.35 22.9223C115.227 22.6376 115.308 2.3555 115.312 0.0438646Z"
			fill="currentColor"
		/>
		<path
			d="M154.079 0.0344206L154.937 0.0279146C154.97 2.29002 154.941 4.62746 154.941 6.89438L154.947 22.9386L154.011 22.9445L153.125 22.9463C153.077 20.3307 153.122 17.5685 153.121 14.943L153.124 0.047606C153.434 0.0368923 153.767 0.0383243 154.079 0.0344206Z"
			fill="currentColor"
		/>
		<path
			d="M122.831 0.0348932L123.768 0.0414429L123.767 22.9546L122.809 22.9476V2.44573C122.809 1.82828 122.773 0.610308 122.831 0.0348932Z"
			fill="currentColor"
		/>
		<path
			d="M97.6245 0.0314039C97.9398 0.0319678 98.2552 0.0350477 98.5705 0.0405997C98.6038 2.62394 98.5738 5.27767 98.5739 7.86578L98.5738 22.9537L97.6219 22.9537C97.5677 19.8475 97.6168 16.5907 97.6167 13.4745L97.6245 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M132.632 0.0364022L134.427 0.0331486L134.434 22.8364L134.423 22.8871C134.253 22.9893 132.898 22.9456 132.608 22.9437C132.572 21.1322 132.604 19.2004 132.604 17.377L132.601 2.10566C132.601 1.75553 132.576 0.323806 132.632 0.0364022Z"
			fill="currentColor"
		/>
		<path
			d="M113.955 0.0245908C114.266 0.0226823 114.586 0.0376904 114.897 0.0481872C114.961 2.77549 114.905 5.73077 114.905 8.47281L114.902 22.9567C114.597 22.9458 114.251 22.9547 113.942 22.956L113.942 7.84023C113.942 5.28643 113.896 2.56759 113.955 0.0245908Z"
			fill="currentColor"
		/>
		<path
			d="M139.147 0.0261699L140.092 0.0420451C140.162 2.53863 140.1 5.3529 140.1 7.87039L140.098 22.9547L139.138 22.9483L139.134 10.0696C139.134 6.75743 139.089 3.33066 139.147 0.0261699Z"
			fill="currentColor"
		/>
		<path
			d="M106.479 0.0279146L107.451 0.0430525C107.497 3.29029 107.455 6.65612 107.455 9.91225L107.449 22.9418C107.133 22.9508 106.793 22.9453 106.475 22.9453L106.479 0.0279146Z"
			fill="currentColor"
		/>
		<path
			d="M111.826 0.0366379C112.284 0.0644847 113.104 0.0420605 113.586 0.0425376L113.588 22.957C112.996 22.948 112.388 22.9531 111.796 22.9517L111.798 6.08782L111.794 1.9294C111.793 1.60639 111.772 0.291077 111.826 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M144.459 0.0366379C145.052 0.0409754 145.645 0.042016 146.238 0.0397605L146.236 22.9539C145.646 22.9418 145.038 22.9507 144.447 22.9525L144.445 2.82562C144.445 1.95582 144.416 0.895466 144.459 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M128.122 0.0331486C128.706 0.0521903 129.331 0.0418679 129.918 0.0422583L129.92 20.3236C129.921 21.0624 129.957 22.242 129.907 22.9565C129.311 22.9512 128.715 22.9502 128.119 22.9533L128.122 0.0331486Z"
			fill="currentColor"
		/>
		<path
			d="M148.943 0.0287531C149.55 0.0260638 150.158 0.0298375 150.766 0.0401607L150.766 22.9387C150.165 22.9539 149.543 22.9445 148.94 22.9427L148.943 0.0287531Z"
			fill="currentColor"
		/>
		<path
			d="M160.782 0.0462098C161.378 0.0371878 161.973 0.0359736 162.569 0.0425233L162.571 20.27C162.571 20.6213 162.604 22.8395 162.519 22.9543C161.938 22.945 161.357 22.9467 160.776 22.9594L160.782 0.0462098Z"
			fill="currentColor"
		/>
		<path
			d="M105.214 0.0360554L105.947 0.0331486L105.944 22.9531L104.975 22.9498L104.158 22.954C104.122 20.0478 104.153 17.0745 104.153 14.1639L104.156 0.0504984C104.502 0.0391774 104.867 0.0403929 105.214 0.0360554Z"
			fill="currentColor"
		/>
		<path
			d="M126.978 0.0281541C127.109 0.0214743 127.162 0.00729015 127.28 0.0555667C127.355 0.185779 127.324 3.50242 127.324 3.92728L127.323 21.3816C127.323 21.6862 127.349 22.6859 127.306 22.9143L127.234 22.9621C127.094 22.9614 127.007 22.9748 126.884 22.9098C126.819 22.744 126.86 19.2625 126.86 18.835L126.858 2.42702C126.857 1.7331 126.829 0.757637 126.867 0.0845413L126.978 0.0281541Z"
			fill="currentColor"
		/>
		<path
			d="M88.7577 0.0347449L89.6274 0.0314039L89.6264 15.0671C89.6263 17.6173 89.6907 20.4345 89.6128 22.9564C89.3362 22.9474 89.0407 22.95 88.7622 22.9473L87.8268 22.9572L87.8241 0.0503157C88.1283 0.0392984 88.4516 0.0393427 88.7577 0.0347449Z"
			fill="currentColor"
		/>
		<path
			d="M130.274 0.0265057C130.587 0.0238165 130.908 0.0378697 131.221 0.0475857C131.255 2.61271 131.224 5.25746 131.224 7.82822L131.224 22.9578L130.272 22.957L130.274 0.0265057Z"
			fill="currentColor"
		/>
		<path
			d="M83.6349 0.0358053C84.2333 0.0440899 84.832 0.0438285 85.4304 0.0348932L85.4284 22.9457L83.6321 22.9511C83.6002 21.6972 83.6278 20.3214 83.6278 19.0601L83.6253 4.15189C83.6249 2.80874 83.6003 1.37046 83.6349 0.0358053Z"
			fill="currentColor"
		/>
		<path
			d="M121.124 0.0354042L122.277 0.0331486L122.274 22.9466L121.868 22.9505L120.474 22.9492C120.434 20.3501 120.47 17.6476 120.47 15.0415L120.472 0.0496313L121.124 0.0354042Z"
			fill="currentColor"
		/>
		<path
			d="M146.605 0.0261699C146.916 0.0300303 147.226 0.0371007 147.537 0.0473373C147.577 2.65826 147.545 5.35121 147.545 7.96725L147.546 22.9555L146.595 22.9567C146.651 20.8159 146.597 18.4186 146.597 16.261L146.605 0.0261699Z"
			fill="currentColor"
		/>
		<path
			d="M99.9765 0.0380955C100.568 0.0305483 101.16 0.0293764 101.752 0.0346248C101.81 2.53143 101.76 5.23657 101.76 7.74738L101.765 22.9483L99.958 22.9505C99.8941 17.8219 99.9559 12.552 99.9554 7.41205L99.9532 2.49066C99.953 1.94426 99.9169 0.525632 99.9765 0.0380955Z"
			fill="currentColor"
		/>
		<path
			d="M81.3067 0.0366379L82.2454 0.0372891C82.3108 2.49584 82.2513 5.2466 82.2512 7.72454L82.2523 22.9512L81.3006 22.9538L81.2976 8.33621C81.2974 5.58311 81.2735 2.78632 81.3067 0.0366379Z"
			fill="currentColor"
		/>
		<path
			d="M124.676 0.0502178C124.818 0.0412825 124.923 0.0219799 125.058 0.0671334C125.149 0.195394 125.11 2.33175 125.11 2.66439L125.113 22.9588C124.958 22.9514 124.858 22.9929 124.717 22.9255C124.64 22.7771 124.674 20.639 124.674 20.3509L124.676 0.0502178Z"
			fill="currentColor"
		/>
		<path
			d="M137.43 0.0351142L138.6 0.0279146C138.646 1.89882 138.607 3.96235 138.607 5.84743L138.606 17.1655C138.605 19.0111 138.557 21.1114 138.624 22.9414L137.977 22.9469L136.797 22.9467C136.729 20.4437 136.793 17.6243 136.793 15.1004L136.794 0.0485617L137.43 0.0351142Z"
			fill="currentColor"
		/>
		<path
			d="M155.467 0.0314039L156.416 0.0396016L156.417 22.9531L155.462 22.9468L155.467 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M90.1605 0.0314039L91.1199 0.0320115L91.1157 22.94C90.8109 22.9518 90.4597 22.9461 90.1509 22.9475L90.1491 8.02779C90.1489 5.4147 90.1018 2.62658 90.1605 0.0314039Z"
			fill="currentColor"
		/>
		<path
			d="M95.4788 0.0348932C95.9956 0.0610918 96.7363 0.0399686 97.2702 0.0413132L97.2721 20.4874C97.2725 21.0794 97.3094 22.4182 97.2565 22.9525C96.6694 22.9442 96.06 22.9522 95.4712 22.9529L95.4659 3.11401C95.4656 2.11508 95.4445 1.02866 95.4788 0.0348932Z"
			fill="currentColor"
		/>
		<path
			d="M110.844 0.00872331C110.949 0.0450717 110.907 0.0150558 110.977 0.10198C111.009 0.803876 110.982 1.62484 110.981 2.33823L110.982 19.5277C110.983 19.8587 111.017 22.8084 110.944 22.937L110.685 22.9939L110.593 22.9419C110.509 22.8061 110.534 22.7275 110.534 22.5463C110.531 17.7533 110.532 12.9569 110.532 8.16425L110.531 2.87734C110.531 2.10921 110.493 0.859961 110.545 0.120718C110.634 0.00985109 110.67 0.037134 110.844 0.00872331Z"
			fill="currentColor"
		/>
		<path
			d="M116.288 0.036687C116.88 0.0237179 117.498 0.032653 118.092 0.0327398C118.119 1.96805 118.094 3.96288 118.094 5.90192L118.094 17.2779C118.094 19.1465 118.071 21.0774 118.106 22.9419C117.507 22.9559 116.88 22.947 116.278 22.9473C116.24 21.4017 116.274 19.707 116.274 18.1521L116.273 3.03799C116.272 2.22271 116.23 0.819088 116.288 0.036687Z"
			fill="currentColor"
		/>
	</svg>
</template>
